import React, { useEffect, useState } from 'react'

import './Galerie.css'

function Galerie() {
    const [photos, setPhotos] = useState([]);
    const [uuids, setUuids] = useState([]);
    const [thisPicture, setThisPicture] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [qrCodes, setQRCodes]= useState([]);

    useEffect(() => {
        fetchData();
        
      }, []
      );


    const fetchData = async () => {
      var this_photos = []
      var this_uuids = []
      await fetch('https://coasters.davidschnieders.de/backend/files')
      .then(response => response.json())
      .then(data => {
        data.files.forEach(filename => {
          this_photos.push(`https://coasters.davidschnieders.de/backend/files/${filename}`)
          this_uuids.push(`${filename}`)
        })
      })
      .catch(error => console.error('Error fetching files:', error));

      setPhotos(this_photos);
      setUuids(this_uuids);

      
      var this_qr_codes = []
      await fetch('https://coasters.davidschnieders.de/backend/qr_codes')
      .then(response => response.json())
      .then(data => {
        data.qr_codes.forEach(qr_code => {
          this_qr_codes.push(qr_code)
        })
      })
      .catch(error => console.error('Error fetching files:', error));

      setQRCodes(this_qr_codes);

    };

    const deletePicture = async (uuid) => {
        await fetch(`https://coasters.davidschnieders.de/backend/delete/${uuid}`,{
            method: "POST",
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });
        window.location.reload();
    }

    const openAssignModal = (uuid) => {
      setThisPicture(uuid);
      setModalOpen(true);
    }

    const closeAssignModal = () => {
      setModalOpen(false)
    }

    const assignQrCode = async (uuid) => {
      await fetch(`https://coasters.davidschnieders.de/backend/assign/${thisPicture}/${uuid}`,{
        method: "POST",
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    });
    window.location.reload();
    }


return (
    <div className="photo-album">
      <div className="photo-container">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo"
          >
            <div className="photo-frame">
              <img src={photo} alt={`Photo ${index + 1}`} />
              <div className="photo-text">
                <button className='funktionsknopf' onClick={ () => {deletePicture(uuids[index])}} >Löschen</button>
                <button className='funktionsknopf' onClick={ () => {openAssignModal(uuids[index])}}>Zuordnen</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {modalOpen && (
        <div className="assignModal">
        <div className="assignModalContent">
          <span className="close" onClick={closeAssignModal}>&times;</span>
          <div className="qrCodeTable">
          <table>
            <tr>
              <th>Nr.</th>
              <th>Bild</th>
              <th>Zuordnen?</th>
            </tr>
            {qrCodes.map( qr_code => (
              <tr>
                <td>{qr_code.id}</td>
                <td>{qr_code.picture && (<img className="table_foto" src={`https://coasters.davidschnieders.de/backend/files/${qr_code.picture}`} alt={qr_code.picture} />)} </td>
                <td><button onClick={ () => {assignQrCode(qr_code.uuid)}}>Zuordnen</button></td>
              </tr>
            ))}
          </table>
          </div>
        </div>
      </div>
      )}
    </div>
  );

};
  export default Galerie;
